var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useMemo } from 'react';
import { Form, Spin } from 'antd';
import { useParams } from 'react-router-dom';
import { useTicketTypesGroupsQuery } from 'apollo/queries/TICKET_TYPES_GROUPS';
import { useTeamTicketTypesQuery } from 'apollo/queries/Teams/TEAM_TICKET_TYPES';
import useTeamUpdateTicketTypesMutation from 'apollo/mutations/Teams/TEAM_UPDATE_TICKET_TYPES';
import { Button as SubmitButton } from 'ui/styled';
import { isNilOrEmpty } from 'utils/helpers';
import GroupSelect from './GroupSelect';
import { StickyFooter } from './styled';
import { calculateTeamTicketTypesInitialValues, calculateFlatChanges } from './helpers';
var TicketTypes = function () {
    var id = useParams().id;
    var form = Form.useForm()[0];
    var _a = useTicketTypesGroupsQuery({ variables: { first: 200 } }), ticketTypeGroupsData = _a.data, ticketTypeGroupsLoading = _a.loading;
    var ticketTypeGroups = useMemo(function () {
        var _a;
        var nodes = (_a = ticketTypeGroupsData === null || ticketTypeGroupsData === void 0 ? void 0 : ticketTypeGroupsData.ticket_type_groups) === null || _a === void 0 ? void 0 : _a.nodes;
        if (isNilOrEmpty(nodes))
            return [];
        return nodes.map(function (currentItem) { return (__assign(__assign({}, currentItem), { items: currentItem.ticket_types })); });
    }, [ticketTypeGroupsData]);
    var _b = useTeamTicketTypesQuery({ variables: { id: id } }), teamTicketTypesData = _b.data, teamTicketTypesLoading = _b.loading;
    var _c = useTeamUpdateTicketTypesMutation(), onTeamUpdateTicketTypes = _c.onMutate, teamTicketTypesUpdateLoading = _c.loading;
    var initialValues = useRef(calculateTeamTicketTypesInitialValues(teamTicketTypesData));
    useEffect(function () {
        initialValues.current = calculateTeamTicketTypesInitialValues(teamTicketTypesData);
        form.setFieldsValue(initialValues.current);
    }, [form, teamTicketTypesData]);
    var onFinish = function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var isErrorFree;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, onTeamUpdateTicketTypes(__assign({ team_id: id }, calculateFlatChanges(initialValues.current, values)))];
                case 1:
                    isErrorFree = (_a.sent()).isErrorFree;
                    if (isErrorFree) {
                        initialValues.current = values;
                        form.setFieldsValue(values);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var showSpinner = ticketTypeGroupsLoading || teamTicketTypesLoading;
    return (_jsx(Spin, { spinning: showSpinner, children: _jsxs(Form, { preserve: true, form: form, onFinish: onFinish, initialValues: initialValues.current, children: [ticketTypeGroups === null || ticketTypeGroups === void 0 ? void 0 : ticketTypeGroups.map(function (group) { return (_jsx(GroupSelect, { form: form, group: group }, group.id)); }), _jsx(StickyFooter, { children: _jsx(SubmitButton, { btntype: "primary", htmlType: "submit", "data-test": "teamTicketTypesUpdateBtn", loading: teamTicketTypesUpdateLoading, disabled: teamTicketTypesUpdateLoading, children: "Save" }, "submit") })] }) }));
};
export default TicketTypes;
